import { Box, Typography } from '@mui/material';

export function locationCoordinates(location) {
    const latitude = location?.Latitude;
    const longitude = location?.Longitude;
    if ([latitude, longitude].some(value => value == null || String(value).trim() === '' || typeof value === 'boolean')) return null;
    const lat = Number(latitude), lng = Number(longitude);
    return Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180
        ? { lat, lng } : null;
}

export function locationTime(value) {
    const date = value ? new Date(value) : null;
    return date && Number.isFinite(date.getTime())
        ? date.toLocaleString('en-US', { timeZoneName: 'short' }) : 'Unavailable';
}

export default function LocationDetails({ location, isUsingHomeLocation }) {
    return <Box component="section" aria-label="Saved location" sx={{ overflowWrap: 'anywhere' }}>
        <Typography component="h2" variant="h6">{isUsingHomeLocation ? 'Home location' : 'Last known location'}</Typography>
        <Typography>{location?.address || 'Location address unavailable'}</Typography>
        {isUsingHomeLocation
            ? <Typography color="text.secondary">Showing the customer’s home location because a device location is unavailable.</Typography>
            : <Typography color="text.secondary">Location as of: {locationTime(location?.EventTime)}</Typography>}
    </Box>;
}
